export const APP_NAME = "DPKP Kota Bandung";
export const PERSIST_STORE_NAME =
  "dQkqYPBWHcyT42nubZEzMDFeKjV75Xx6UgwNfGmtvCJpRAhLS8";
export const REDIRECT_URL_KEY = "redirectUrl";
